import type { ChipsetService } from './types.ts'

const LOCALE = 'en-US'

export const currencyFormatter = new Intl.NumberFormat(LOCALE, {
	style: 'currency',
	currencyDisplay: 'narrowSymbol',
	currency: 'USD',
	minimumFractionDigits: 0,
	maximumFractionDigits: 2,
}).format

export const preciseCurrencyFormatter = new Intl.NumberFormat(LOCALE, {
	style: 'currency',
	currencyDisplay: 'narrowSymbol',
	currency: 'USD',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
}).format

export const currencyFormatterLargeAmount = new Intl.NumberFormat(LOCALE, {
	style: 'currency',
	currencyDisplay: 'narrowSymbol',
	currency: 'USD',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
}).format

export const currencyFormatterSmallAmount = new Intl.NumberFormat(LOCALE, {
	style: 'currency',
	currencyDisplay: 'narrowSymbol',
	currency: 'USD',
	minimumFractionDigits: 2,
	maximumFractionDigits: 9,
}).format

export const amountFormatter = new Intl.NumberFormat(LOCALE, {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
}).format

export const serviceUnit = (service: ChipsetService, quantity: number = 1) =>
	quantity === 1 ? service.unit.singular : service.unit.plural
